<template>
  <div class="home">
    <div class="home__slider">
      <adx-home-slider :slide="3" :isCenterMobile="true" :arrowMobile="false" :data="detailSlider" />
    </div>
    <div class="home__main">
      <adx-sidebar />
      <div class="home__main__right container-router">
        <div class="item">
          <div class="item__child">
            <div class="item__child__left">
              <h1 class="title regular-font" :style="{ color: '#ff2d55' }">SPBU Pertamina</h1>
              <p class="description subhead">Dengan kombinasi ruang luas, ide kreatif, dan teknologi yang kami sediakan, Anda dapat berinteraksi langsung dengan audience Anda dengan beriklan di SPBU Pertamina. Dengan lebih dari 100 SPBU Pertamina di Indonesia, Anda pasti bisa menemukan lokasi yang tepat untuk campaign brand Anda.</p>
              <button class="link explore subhead" @click="goToSpbu">Explore SPBU<span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
            </div>
            <div class="item__child__right">
              <div class="banner">
                <img src="/img/newhome/section-spbu.jpg" @click="goToSpbu" alt="">
              </div>
            </div>
          </div>
          <div class="item__child">
            <div class="item__child__left">
              <h1 class="title regular-font" :style="{ color: '#007aff' }">BUS ADVERTISING</h1>
              <p class="description subhead">Beriklan di distrik bisnis dan daerah komersial Jakarta dengan Bus Advertising dari ADX Asia. Melewati daerah-daerah teramai di Jakarta, bus advertising membantu memperkenalkan brand Anda ke commuters, pejalan kaki, dan mereka yang menyetir di jalan di lokasi-lokasi paling ramai di Jakarta.</p>
              <button class="link explore subhead" @click="goToBus">Explore Bus Advertising<span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
            </div>
            <div class="item__child__right">
              <div class="banner">
                <img src="/img/newhome/section-bus.jpg" @click="goToBus" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home__other">
      <div class="home__other__title">
        <h1 class="small-title">Other Places for Advertising</h1>
      </div>
      <div class="home__other__item">
        <router-link :to="{path: card.link}" tag="div" class="item" v-for="(card, i) in cards" :key="i" :style="{backgroundImage: 'url(' + card.url + ')'}">
          <div class="overlay">
            <div class="title">{{card.title}}</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="home__brands">
      <div class="container">
        <div class="item" v-for="i in clients" :key="i">
          <img :src="i" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailSlider from '@/components/Slider/DetailSlider'
import HomeSlider from '@/components/Slider/HomeSlider'
import Sidebar from '@/components/SideBar/Desktop'

export default {
  name: 'adx-home-v2',
  components: {
    'adx-detail-slider': DetailSlider,
    'adx-sidebar': Sidebar,
    'adx-home-slider': HomeSlider,
  },
  props: {

  },
  data() {
    return {
      detailSlider: [
        {
          id: 1,
          url: '/img/newhome/banner1.jpg',
          thumbnail: '/img/newhome/banner1.jpg',
          viewer_url: '/img/newhome/banner1.jpg',
          description: 'SPBU Advertising Now Available Exclusively',
          path: '/spbu'
        },
        {
          id: 2,
          url: '/img/newhome/banner2.jpg',
          thumbnail: '/img/newhome/banner2.jpg',
          viewer_url: '/img/newhome/banner2.jpg',
          description: 'Travel Your Advertisement Accross The City',
          path: '/results/bus'
        },
        {
          id: 3,
          url: '/img/newhome/banner3.jpg',
          thumbnail: '/img/newhome/banner3.jpg',
          viewer_url: '/img/newhome/banner3.jpg',
          description: 'Advertisement For Everyone',
          path: '/experience-branding'
        },
        {
          id: 4,
          url: '/img/newhome/banner1.jpg',
          thumbnail: '/img/newhome/banner1.jpg',
          viewer_url: '/img/newhome/banner1.jpg',
          description: 'SPBU Advertising Now Available Exclusively',
          path: '/spbu'
        },
        {
          id: 5,
          url: '/img/newhome/banner2.jpg',
          thumbnail: '/img/newhome/banner2.jpg',
          viewer_url: '/img/newhome/banner2.jpg',
          description: 'Travel Your Advertisement Accross The City',
          path: '/results/bus'
        },
        {
          id: 6,
          url: '/img/newhome/banner3.jpg',
          thumbnail: '/img/newhome/banner3.jpg',
          viewer_url: '/img/newhome/banner3.jpg',
          description: 'Advertisement For Everyone',
          path: '/experience-branding'
        }
      ],
      cards: [
        {
          color: 'linear-gradient(225deg, rgba(245, 128, 2, 0.6), #fe4304)',
          title: 'Restaurant',
          url: '/img/newhome/Categories-Restaurant.jpg',
          link: 'lifestyle?property_type=RE&sort_by=traffic'
        },
        {
          color: 'linear-gradient(225deg, rgba(0, 255, 255, 0.5), #026bde)',
          title: 'Malls',
          url: '/img/newhome/Categories-Cafe.jpg',
          link: '/coming-soon'
        },
        {
          color: 'linear-gradient(225deg, rgba(255, 92, 199, 0.5), #692bd9)',
          title: 'Hangout Place',
          url: '/img/newhome/Categories-HoP.jpg',
          link: '/coming-soon'
        },
        {
          color: 'linear-gradient(225deg, rgba(255, 92, 92, 0.5), #d92b2c)',
          title: 'Barbershop',
          url: '/img/newhome/Categories-Barbershop.jpg',
          link: '/coming-soon'
        },
        {
          color: 'linear-gradient(225deg, rgba(28, 224, 66, 0.5), #408502)',
          title: 'Salon & Beauty',
          url: '/img/newhome/Categories-Saloom.jpg',
          link: 'lifestyle?property_type=SL&sort_by=traffic'
        },
        {
          color: 'linear-gradient(225deg, #fc5914, #f63542)',
          title: 'Airport Media',
          url: '/img/newhome/Categories-Airport.jpg',
          link: '/coming-soon'
        },
        {
          color: 'linear-gradient(225deg, #85efbf, #0c844e)',
          title: 'Fitness Club',
          url: '/img/newhome/Categories-Fitness.jpg',
          link: 'lifestyle?property_type=GY&sort_by=traffic'
        },
        {
          color: 'linear-gradient(225deg, #00edfb, #026bde)',
          title: 'Supermarket',
          url: '/img/newhome/Categories-Supermarket.jpg',
          link: 'lifestyle?property_type=SP&sort_by=traffic'
        },
        {
          color: 'linear-gradient(225deg, #d7ea0d, #ff03be)',
          title: 'Airport Lounge',
          url: '/img/newhome/Categories-Lounge.jpg',
          link: 'airport?sort_by=traffic'
        },
        {
          color: 'linear-gradient(225deg, #0deabf, #ff3a00)',
          title: 'Inflight',
          url: '/img/newhome/Categories-inflight.jpg',
          link: '/coming-soon'
        }
      ],
      clients: [
        '/img/newhome/client-blibli.png',
        '/img/newhome/client-hp.png',
        '/img/newhome/client-lazada.png',
        '/img/newhome/client-oppo.png',
        '/img/newhome/client-polytron.png',
        '/img/newhome/client-ponds.png',
        '/img/newhome/client-samsung.png',
        '/img/newhome/client-Shopee.png',
        '/img/newhome/client-tokopedia.png',
        '/img/newhome/client-traveloka.png',
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goToBus(){
      this.$router.push({ name: `bus` })
    },
    goToSpbu(){
      this.$router.push({ name: `spbu` })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>